/**
 * 埋点运行时配置（与 Mobile src/analytics/config 对齐）。
 * 上报域名与主业务 API 分离。
 */

function readEnvFlag(raw: string | undefined, defaultValue: boolean): boolean {
  if (raw == null || String(raw).trim() === '') return defaultValue
  const v = String(raw).trim().toLowerCase()
  if (v === '1' || v === 'true' || v === 'yes' || v === 'on') return true
  if (v === '0' || v === 'false' || v === 'no' || v === 'off') return false
  return defaultValue
}

const rawBase = String(import.meta.env.VITE_ANALYTICS_URL ?? '')
  .trim()
  .replace(/\/+$/, '')

/** 例：https://www.difisec.vip/report/v1 */
export function getAnalyticsBaseURL(): string {
  return rawBase
}

export function isAnalyticsEnabled(): boolean {
  if (!rawBase) return false
  return readEnvFlag(import.meta.env.VITE_ANALYTICS_ENABLED as string | undefined, false)
}

export function getAnalyticsProjectId(): string | number {
  const raw = String(import.meta.env.VITE_ANALYTICS_PROJECT_ID ?? '').trim()
  if (!raw) return 10001
  const asNum = Number(raw)
  return Number.isFinite(asNum) && String(asNum) === raw ? asNum : raw
}

export function getAnalyticsChannel(): string {
  const raw = String(import.meta.env.VITE_MODE ?? import.meta.env.MODE ?? '').trim()
  return raw || 'h5'
}

export const ANALYTICS_QUEUE_MAX = 100
export const ANALYTICS_BATCH_MAX = 20
export const ANALYTICS_FLUSH_IDLE_TIMEOUT_MS = 5_000
export const ANALYTICS_TRANSPORT_TIMEOUT_MS = 15_000
